import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    DELETE_SUMMARY_REPORT: createActionType(FULL_NAMESPACE, "DELETE_SUMMARY_REPORT"),
    DELETE_SUMMARY_REPORT_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_SUMMARY_REPORT_COMPLETED")
};
